import StyledToastContainer from "./StyledToastContainer";

export default StyledToastContainer;
